import React from "react";
import ConsumptionItem from "../ConsumptionItem";

function Operation({ lang }) {
  return (
    <>
      <section className="container section">
        <h1 className="title-line pb-4 fw-bold">
          {lang === "th"
            ? `การดำเนินงานและการจัดทำรายงาน`
            : ` Operation and Report Preparation`}
        </h1>
        <div className="row">
          <div className="col-lg-7 ">
            <h5 className="fw-bold ">
              {lang === "th"
                ? `การดำเนินงานด้านสิ่งแวดล้อม`
                : `Environment Management`}
            </h5>
            <p className="" style={{ textIndent: "30px" }}>
              {lang === "th"
                ? `บริษัทฯ ตระหนักและให้ความสำคัญถึงผลกระทบจากการดำเนินธุรกิจที่ส่งต่อสิ่งแวดล้อมอยู่เสมอ แม้ว่าในการดำเนินธุรกิจของบริษัทฯ ไม่ส่งผลกระทบต่อสิ่งแวดล้อมโดยตรง แต่เพื่อให้สอดคล้องตามแนวทางการดำเนินธุรกิจอย่างยั่งยืน ซึ่งต้องคำนึงถึงการดำเนินการด้าน สิ่งแวดล้อม สังคม และบรรษัทภิบาลของกิจการ บริษัทฯ จึงมีแนวปฏิบัติการเกี่ยวกับสิ่งแวดล้อมและส่งเสริมให้พนักงานปฏิบัติตามอย่างสม่ำเสมอ เช่น มีการตรวจซ่อมและบำรุงรถยนต์ที่ใช้งานส่วนกลางของบริษัทฯอย่างสม่ำเสมอ การเดินขึ้นลงบันไดแทนการใช้ลิฟต์โดยสาร รณรงค์การใช้กระดาษสองหน้า ลดการใช้กระดาษในกระบวนการทำงาน ปิด/เปิดไฟฟ้าและแอร์ เป็นเวลา และ ปิดแอร์ในช่วงพักกลางวัน รณรงค์ให้พนักงานใช้น้ำอย่างประหยัด และมีเครื่องทำน้ำดื่มไว้บริการพนักงานอย่างเพียงพอ เพื่อลดการซื้อน้ำดื่มที่ใช้ขวดพลาสติก และยังจัดวางถังขยะเพื่อให้พนักงานได้แยกประเภทขยะเพื่อนำขยะที่สามารถรีไซเคิลได้ไปใช้ประโนชน์ได้ต่อไป และในปี 2565 บริษัทฯได้เริ่มดำเนินการในการเก็บรวบรวมสถิติการใช้ไฟฟ้า น้ำ และเชื้อเพลิงที่เกี่ยวข้องกับการดำเนินกิจการของบริษัทฯ เพื่อประเมินคาร์บอนฟุตพริ้นท์ของ บริษัทฯ ซึ่งจะสามารถกำหนดแนวทางและเป้าหมายการดำเนินงานของบริษัทฯ โดยลดการเกิดผลกระทบต่อสิ่งแวดล้อมในอนาคต`
                : ` The Company is aware of the impact of business operations that are transmitted to the environment, although in the business of the Company does not directly affect the environment but in order to comply with sustainable business which must take into account the environmental, social and corporate governance of the business. The Company has guidelines on environmental practices and encourages employees to follow them regularly, for example, having regular maintenance and repairs to the Company's vehicles, walking instead of using the elevator, campaign for the use of two-sided paper and reduce to use of paper in the work process, turn off and turn on electricity and air conditioner for a period of time, campaigning to use water economically and there is enough drinking water to serve the staff to reduce to uses plastic bottles. And in 2022, the Company began collecting statistics on electricity, water, and fuel consumption related to its business operations to assess the Company’s carbon footprint. This will enable the Company to establish directions and goals for its operations, reducing environmental impact in the future.`}
            </p>
            <div className="d-flex justify-content-center py-2">
              <h5 className="bg-blue1 text-white text-center d-inline px-4 py-2 rounded-pill">
                {lang === "th"
                  ? `ปริมาณการใช้น้ำ และไฟฟ้าของสำนักงานใหญ่ ในปี2566`
                  : ` In 2566, water usage and electricity consumption of the main office`}
              </h5>
            </div>
            {/* 107,659 */}
            <ConsumptionItem
              src="/images/sustainable/ความรับผิดชอบต่อสังคม-59_0.png"
              num={107659}
              // classes="five"
              lang={lang}
              title={
                lang === "th"
                  ? `ปริมาณการใช้ไฟฟ้า (กิโลวัตต์)`
                  : `The electricity consumption (kilowatts)`
              }
            />
            {/* 1,679 */}
            <ConsumptionItem
              src="/images/sustainable/ความรับผิดชอบต่อสังคม-60_0.png"
              num={1679}
              classes={"six"}
              lang={lang}
              title={
                lang === "th"
                  ? `ปริมาณการใช้น้ำ (ลูกบาศกเ์มตร)`
                  : `the water usage (cubic meters)`
              }
            />
            <p className="pt-3">
              {lang === "th"
                ? `ทั้งนี้ในปี 2567 บริษัทฯ มีแผนที่จะเข้าร่วมโครงการผลิตไฟฟ้าจากพลังงานแสงอาทิตย์ที่ติดตั้งบนหลังคาเพื่อส่งเสริมการผลิตไฟฟ้า จากพลังงานทดแทน และสามารถขายไฟฟ้าส่วนที่เหลือได้อีกด้วย `
                : `In 2567, the company plans to participate in a solar energy project by installing solar panels on the roof to promote electricity generation from renewable sources. Additionally, they will be able to sell any surplus electricity generated.`}
            </p>
          </div>
          <div
            className="col-lg-5 my-auto"
            id="BgBanner"
            style={{
              backgroundImage:
                "url(/images/sustainable/ความรับผิดชอบต่อสังคม-58_0.jpg)",
              height: "750px",
            }}
          ></div>
        </div>
      </section>

      <section className="bg-gray ">
        <div className="container section">
          <h5 className="fw-bold">
            {lang === "th"
              ? `การดำเนินงานด้านสังคม `
              : `Sustainability Management - Social Dimensions `}
          </h5>
          <p style={{ textIndent: "30px" }}>
            {lang === "th"
              ? `บริษัทฯ มุ่งมั่นปฏิบัติให้สอดคล้องกับกฎหมาย ระเบียบ ข้อบังคับที่เกี่ยวกับการจัดการด้านสังคม โดยมีการกำหนดนโยบายและแนวการปฏิบัติที่อาจกระทบต่อสังคม และผู้มีส่วนได้เสียทุกฝ่าย และสื่อสารให้กรรมการ ผู้บริหาร และพนักงานรับทราบ โดยให้นำไปปฏิบัติตามดังนี้`
              : `The Company is committed to complying with laws, regulations, and policies related to social management. It sets policies and guidelines that may affect society and all stakeholders and communicates these policies and guidelines to the board, executives, and employees, who are responsible for implementing them as follows:
 `}
          </p>
          <h5 className="fw-bold">
            {lang === "th"
              ? `สิทธิมนุษยชนและการปฏิบัติต่อพนักงาน 
 `
              : `Human rights and Employees treatment
 `}
          </h5>
          <p style={{ textIndent: "30px" }}>
            {lang === "th"
              ? `บริษัทฯให้ความเคารพสิทธิมนุษยชนทั้งภายในองค์กรและภายนอกองค์กร โดยปฏิบัติต่อคู่ค้าและผู้ที่ต้องทำการติดต่อเกี่ยวข้องทางธุรกิจกับองค์กรโดยไม่คำนึงถึงเชื้อชาติ ศาสนา หรือปัจจัยอื่นใดที่จะนำมาซึ่งการไม่เคารพสิทธิมนุษยชนอย่างเคร่งครัด ส่วนภายในองค์กรนั้น บริษัทฯ ปฏิบัติต่อพนักงานตามสัญญาว่าจ้างแรงงานอย่างเท่าเทียม และไม่กีดกันทางเพศ เชื้อชาติ ศาสนา หรืออื่นใดที่จะนำมาซึ่งความแตกแยกและไม่เสมอภาค โดยมีแนวปฏิบัติต่อพนักงานเป็นไปตามคู่มือจริยธรรมธุรกิจและแนวทางปฏิบัติเป็นไปตามคู่มือจริยธรรมธุรกิจและแนวทางปฏิบัติ (Code of Conduct) เพื่อใช้เป็นแนวทางในการปฏิบัติงานของพนักงานทุกคน โดยถือว่าข้อปฏิบัติในคู่มือจริยธรรมเป็นส่วนหนึ่งของ “ระเบียบและข้อบังคับพนักงาน” ที่พนักงานพึงปฏิบัติ ทั้งนี้ บริษัทฯ ได้ดำเนินการชี้แจงเรื่องจรรยาบรรณในการดำเนินธุรกิจให้กับพนักงานทุกคน
 `
              : `The Company respects human rights within and outside the organizationThe Company treats its business partners and those who deal with business entities irrespective of race, religion, or other factors that would lead to a serious disregard for human rightsWithin the organization, the Companyequally treats its employees, contract workers and without discrimination, gender, race, religion, or anything else that would bring disunity and inequalityThe practices per the employee are according to the Code of Business Ethics, while the Code of Conduct is the guidance of the work of all employeesIt is considered a practice in the Ethics Guide as a part of the "Employee Rules and  `}
          </p>
          <img
            className="w-100 mt-4"
            src="/images/sustainable/ความรับผิดชอบต่อสังคม-(การดำเนินงาน)-57_0.jpg"
          />
        </div>
      </section>
    </>
  );
}

export default Operation;
